import themeColorsDesingSystem from "assets/theme/ds-colors";
import {
  Autocomplete,
  TextField,
  Tooltip,
  Typography,
  Box,
  FormLabel,
  Skeleton,
} from "@mui/material";
import ListboxComponent from "./list-box-virtualized";

export default function AutoCompleteField({
  optionLabelKey,
  optionIdKey,
  options,
  label,
  value,
  onChange,
  disabled,
  loading = false,
  multiple = false,
  required = false,
  customTooltipText,
}) {
  const getLabel = (option) => option?.[optionLabelKey] || option?.Nome || "";

  const getId = (item) => {
    if (item == null || item === false || item === undefined) return null;
    return item?.[optionIdKey] ?? item?.Id ?? item?.id ?? item;
  };

  return (
    <Box>
      {label && (
        <FormLabel
          sx={{
            color: themeColorsDesingSystem.text.primary,
            fontSize: ".875rem",
            fontWeight: "600",
            lineHeight: 1.5,
            mb: 0,
            fontFamily: "Open Sans,sans-serif",
          }}
        >
          {label}
          {required ? " *" : ""}
        </FormLabel>
      )}
      {loading ? (
        <Skeleton height="2.3em" sx={{ transform: "none" }} />
      ) : (
        <Autocomplete
          blurOnSelect
          disabled={disabled}
          multiple={multiple}
          options={options}
          value={value ?? (multiple ? [] : null)}
          onChange={(_, newValue) => {
            if (onChange) onChange(newValue);
          }}
          fullWidth
          isOptionEqualToValue={(option, val) => getId(option) === getId(val)}
          getOptionLabel={(option) => getLabel(option)}
          noOptionsText="Nenhuma opção encontrada"
          ListboxComponent={ListboxComponent}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused fieldset": {
                    borderColor: themeColorsDesingSystem.primary.main,
                  },
                  "&.Mui-disabled": {
                    backgroundColor: themeColorsDesingSystem.stone.light,
                    cursor: "default",
                  },
                },
                "& .MuiInputBase-input": {
                  fontFamily: "Open Sans,sans-serif",
                  color: themeColorsDesingSystem.text.primary,
                  fontSize: ".875rem",
                  padding: "0 4px 0 5px!important",
                },
                "& .MuiIconButton-root": {
                  padding: 0,
                },
                "& .MuiAutocomplete-root": {
                  marginBottom: "0px",
                },
              }}
            />
          )}
          renderOption={(props, option) => (
            <li {...props}>
              <Tooltip
                arrow
                title={
                  customTooltipText
                    ? customTooltipText(option)
                    : getLabel(option)
                }
                leaveTouchDelay={100}
                disableInteractive
              >
                <Typography
                  noWrap
                  sx={{
                    fontFamily: "Open Sans,sans-serif",
                    color: themeColorsDesingSystem.text.primary,
                    fontSize: ".875rem",
                  }}
                >
                  {getLabel(option)}
                </Typography>
              </Tooltip>
            </li>
          )}
        />
      )}
    </Box>
  );
}
